import React, { useState } from "react";
import { Layout } from "components/layout";
import { Navigate } from "react-router-dom";
import { useAuth } from "hooks/useAuth";
import { DashboardView } from "./components/provider/DashboardView";
import { UploadView } from "./components/provider/UploadView";
import { InvoicesView } from "./components/provider/InvoicesView";
import { CalendarView } from "./components/provider/CalendarView";
import { AdminDashboardView } from "./components/manager/AdminDashboardView";
import { ReportsView } from "./components/manager/ReportsView";
import { ProvidersView } from "./components/manager/ProvidersView";
import { ApprovalsView } from "./components/manager/ApprovalsView";
import { UsersView } from "./components/manager/UsersView";
import { Chatbot } from "components/chatbot";
import "styles/dashboard.css";
import "styles/manager.css";

export const Dashboard = () => {
  const { isLogged, getUserData, setNotification } = useAuth();
  const user = getUserData();

  const [activeTab, setActiveTab] = useState("dashboard");
  const [invoices, setInvoices] = useState([
    {
      id: 1,
      folio: "F-2026-001",
      uuid: "A1B2C3D4-E5F6-7890-ABCD-EF1234567890",
      amount: 25450,
      date: "2026-01-10",
      status: "aprobada",
      paymentDate: "2026-01-15",
      description: "Suministros de limpieza y mantenimiento",
    },
    {
      id: 2,
      folio: "F-2026-002",
      uuid: "B2C3D4E5-F6A7-8901-BCDE-F12345678901",
      amount: 18900,
      date: "2026-01-12",
      status: "revision",
      paymentDate: null,
      description: "Servicios de lavandería mes enero",
    },
    {
      id: 3,
      folio: "F-2026-003",
      uuid: "C3D4E5F6-A7B8-9012-CDEF-123456789012",
      amount: 32100,
      date: "2026-01-08",
      status: "pagada",
      paymentDate: "2026-01-13",
      description: "Mantenimiento aire acondicionado",
    },
    {
      id: 4,
      folio: "F-2025-045",
      uuid: "D4E5F6A7-B8C9-0123-DEFG-234567890123",
      amount: 45800,
      date: "2025-12-28",
      status: "aprobada",
      paymentDate: "2026-01-15",
      description: "Reparación sistema eléctrico",
    },
    {
      id: 5,
      folio: "F-2026-004",
      uuid: "E5F6A7B8-C9D0-1234-EFGH-345678901234",
      amount: 12750,
      date: "2026-01-11",
      status: "recibida",
      paymentDate: null,
      description: "Suministros de papelería",
    },
    {
      id: 6,
      folio: "F-2026-005",
      uuid: "F6A7B8C9-D0E1-2345-FGHI-456789012345",
      amount: 8500,
      date: "2026-01-09",
      status: "rechazada",
      paymentDate: null,
      description: "Factura con datos incorrectos - Favor de reenviar",
    },
  ]);

  const [providers, setProviders] = useState([
    {
      id: 1,
      name: "Suministros Ejemplo S.A.",
      rfc: "SEJ850101ABC",
      email: "contacto@ejemplo.com",
      paymentDays: 15,
      status: "active",
    },
    {
      id: 2,
      name: "Servicios Integrales MX",
      rfc: "SIM920315DEF",
      email: "ventas@servicios.mx",
      paymentDays: 30,
      status: "active",
    },
    {
      id: 3,
      name: "Distribuidora del Norte",
      rfc: "DNO881205GHI",
      email: "facturas@norte.com",
      paymentDays: 20,
      status: "active",
    },
  ]);

  const handleUploadInvoice = (files, orderNumber) => {
    // Simular carga de factura
    const newInvoice = {
      id: invoices.length + 1,
      folio: `F-2026-${String(invoices.length + 1).padStart(3, "0")}`,
      uuid: generateUUID(),
      amount: Math.floor(Math.random() * 50000) + 5000,
      date: new Date().toISOString().split("T")[0],
      status: "recibida",
      paymentDate: null,
      description: "Nueva factura cargada",
    };

    setInvoices([newInvoice, ...invoices]);
    setNotification({
      message:
        "✓ Facturas cargadas exitosamente. Recibirás una notificación cuando sean revisadas.",
      type: "success",
    });
  };

  const generateUUID = () => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16).toUpperCase();
      },
    );
  };

  const handleApproveInvoice = (invoiceId) => {
    setInvoices((prevInvoices) =>
      prevInvoices.map((inv) => {
        if (inv.id === invoiceId) {
          const paymentDate = new Date();
          paymentDate.setDate(paymentDate.getDate() + 15);
          return {
            ...inv,
            status: "aprobada",
            paymentDate: paymentDate.toISOString().split("T")[0],
          };
        }
        return inv;
      }),
    );

    const invoice = invoices.find((inv) => inv.id === invoiceId);
    setNotification({
      message: `Factura ${invoice?.folio} aprobada y programada para pago`,
      type: "success",
    });
  };

  const handleRejectInvoice = (invoiceId) => {
    setInvoices((prevInvoices) =>
      prevInvoices.map((inv) => {
        if (inv.id === invoiceId) {
          return {
            ...inv,
            status: "rechazada",
            description: inv.description + " - Rechazada por el administrador",
          };
        }
        return inv;
      }),
    );

    const invoice = invoices.find((inv) => inv.id === invoiceId);
    setNotification({
      message: `Factura ${invoice?.folio} rechazada`,
      type: "error",
    });
  };

  const handleRequestChanges = (invoiceId) => {
    setInvoices((prevInvoices) =>
      prevInvoices.map((inv) => {
        if (inv.id === invoiceId) {
          return { ...inv, status: "revision" };
        }
        return inv;
      }),
    );

    const invoice = invoices.find((inv) => inv.id === invoiceId);
    setNotification({
      message: `Se ha solicitado revisión para la factura ${invoice?.folio}`,
      type: "info",
    });
  };

  const handleUpdatePaymentDays = (providerId, days) => {
    setProviders((prevProviders) =>
      prevProviders.map((provider) => {
        if (provider.id === parseInt(providerId)) {
          return { ...provider, paymentDays: days };
        }
        return provider;
      }),
    );

    const provider = providers.find((p) => p.id === parseInt(providerId));
    setNotification({
      message: `Configuración actualizada para ${provider?.name}`,
      type: "success",
    });
  };

  const handleEditProvider = (providerId) => {
    setNotification({
      message: "Función de edición en desarrollo",
      type: "info",
    });
  };

  const handleAddProvider = () => {
    setNotification({
      message: "Modal de agregar proveedor en desarrollo",
      type: "info",
    });
  };

  const tabs = [
    {
      id: "dashboard",
      label: "Dashboard",
      icon: "bi-speedometer2",
      roles: ["administrador", "proveedor"],
    },
    {
      id: "upload",
      label: "Cargar Facturas",
      icon: "bi-cloud-upload",
      roles: ["proveedor"],
    },
    {
      id: "calendar",
      label: "Calendario",
      icon: "bi-calendar-check",
      roles: ["administrador", "proveedor"],
    },
    {
      id: "invoices",
      label: user.rol === "administrador" ? "Facturas" : "Mis Facturas",
      icon: "bi-file-earmark-text",
      roles: ["administrador", "proveedor"],
    },
    {
      id: "reports",
      label: "Costos",
      icon: "bi-graph-up-arrow",
      roles: ["administrador"],
    },
    {
      id: "providers",
      label: "Proveedores",
      icon: "bi-people",
      roles: ["administrador"],
    },
     {
      id: "users",
      label: "Usuarios",
      icon: "bi-people",
      roles: ["administrador"],
    },
    {
      id: "approvals",
      label: "Validación",
      icon: "bi-check-circle",
      roles: ["administrador"],
    },
  ];

  // Redirigir si no está logueado
  //   if (!isLogged) {
  //     return <Navigate to="/signIn" />;
  //   }

  const visibleTabs = tabs.filter((tab) => tab.roles.includes(user.rol));

  return (
    <Layout>
      <div className="container">
        <div className="welcome-section">
          <h1 className="welcome-title">Bienvenido al Portal de Proveedores</h1>
          <p className="welcome-subtitle">
            Gestione sus facturas, consulte el estatus de pagos y mantenga
            control de su información financiera en tiempo real
          </p>
        </div>

        <div className="tabs">
          {visibleTabs.map((tab) => (
            <button
              key={tab.id}
              className={`tab ${activeTab === tab.id ? "active" : ""}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <i className={`bi ${tab.icon}`}></i>
              {tab.label}
            </button>
          ))}
        </div>
      </div>
      <div className="container">
        <div className="tab-content-container">
          {activeTab === "dashboard" && user.rol === "proveedor" && (
            <DashboardView invoices={invoices} />
          )}

          {activeTab === "dashboard" && user.rol === "administrador" && (
            <AdminDashboardView invoices={invoices} providers={providers} />
          )}
          {user.rol === "proveedor" && activeTab === "upload" && (
            <UploadView onUpload={handleUploadInvoice} />
          )}

          {user.rol === "proveedor" && activeTab === "invoices" && (
            <InvoicesView invoices={invoices} />
          )}

          {user.rol === "proveedor" && activeTab === "calendar" && (
            <CalendarView invoices={invoices} />
          )}
          {user.rol === "administrador" && activeTab === "invoices" && (
            <InvoicesView invoices={invoices} />
          )}

          {user.rol === "administrador" && activeTab === "calendar" && (
            <CalendarView invoices={invoices} />
          )}

          {user.rol === "administrador" && activeTab === "reports" && (
            <ReportsView invoices={invoices} />
          )}

          {user.rol === "administrador" && activeTab === "providers" && (
            <ProvidersView
              providers={providers}
              onUpdatePaymentDays={handleUpdatePaymentDays}
              onEditProvider={handleEditProvider}
              onAddProvider={handleAddProvider}
            />
          )}
          
            {user.rol === "administrador" && activeTab === "users" && (
            <UsersView/>
          )}

          {user.rol === "administrador" && activeTab === "approvals" && (
            <ApprovalsView
              invoices={invoices}
              onApprove={handleApproveInvoice}
              onReject={handleRejectInvoice}
              onRequestChanges={handleRequestChanges}
            />
          )}


        </div>
      </div>
      <Chatbot />
    </Layout>
  );
};
